import React, { useEffect, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import { Input } from './Input'
import Form from './Form'
import { Student, Educator } from '../../../models/_models'
import 'react-toastify/dist/ReactToastify.css'

const InlineInput = ({ modelId, attributeName, attributeValue, model = 'student',
                       initialCurrentModel = undefined,
                       fontColor = '#000',
                       minWidth = '40px', minHeight = '40px', textAlign = '',
                       textDecoration = '',
                       cursor = '',
                       defaultValue = '',
                       fontSize = 16 }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [currentModel, setCurrentModel] = useState();
  const [currentAttributeValue, setCurrentAttributeValue] = useState();

  useEffect(() => {
    setCurrentAttributeValue(attributeValue);
  }, [attributeValue])

  useEffect(() => {
    setCurrentModel(initialCurrentModel);
  }, [initialCurrentModel])

  useEffect(() => {
    if (currentModel) return;
    if (!isEditing) return;

    if (model === 'student') {
      Student.find(modelId).then((res) => {
        setCurrentModel(res.data)
      })
    } else {
      Educator.find(modelId).then((res) => {
        setCurrentModel(res.data)
      })
    }
  }, [isEditing]);

  // Called two ways: on blur with the browser event, and on Enter by the Form
  // wrapper's react-hook-form handleSubmit with the VALUES object ({ name: value }).
  // Read whichever arrived; reading event.target off the values object crashed
  // every Enter on the student table.
  const handleSubmit = (newValues) => {
    if (!currentModel) return

    const newValue = newValues && newValues.target ? newValues.target.value : newValues[attributeName];

    let newAttributes = { ...currentModel.attributes, ...{ [attributeName]: newValue } }

    if (model === 'student') {
      newAttributes = { ...newAttributes, validate_student_id: true }
    }

    currentModel.attributes = newAttributes;

    currentModel
      .save()
      .then((res) => {
        if (res) {
          setCurrentAttributeValue(newValue)
          toast('Student was updated successfully', { containerId: modelId })
        } else {
          toast.error('There was an error saving the student. Please make sure the student ID is unique',
            { containerId: modelId })
        }
        setIsEditing(false)
      })
      .catch(() => {
        toast.error('There was an error saving the student', { containerId: modelId })
        setIsEditing(false)
      })
  }

  return (
    <>
      <ToastContainer
        enableMultiContainer
        autoClose={1000}
        position="bottom-right"
        containerId={modelId}
      />

      {isEditing ? (
        <Form
          onSubmit={handleSubmit}>
          <Input
            autoFocus
            hiddenLabel
            rows={3}
            defaultValue={currentAttributeValue}
            fullWidth
            name={attributeName}
            onBlur={handleSubmit}
            inputProps={{style: { fontSize: fontSize, color: fontColor  }}}
          />
        </Form>
      ) : (
        <div style={{ minWidth: minWidth, minHeight: minHeight,
          textDecoration: textDecoration,
          cursor: cursor,
          textAlign: textAlign, color: fontColor }}
             onClick={(e) => setIsEditing(true)}>
          {currentAttributeValue || defaultValue || '  '}
        </div>
      )}
    </>
  )
};

export default InlineInput;
